import './tree.scss'

import { faPlusCircle, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FormApi } from 'final-form';
import { get, set } from 'lodash';
import Component from 'vue-class-component';

import { DefectElement } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { createTranslatedString, EnhancedTextInput, getTranslatedString, ThesaurusSelectField, ThesaurusTermChooser } from '@skinsoft/ui';

import { DefectElementView } from '../defect-element-view';

@Component({
    components: {
        sDefectElementView: DefectElementView,

        sEnhancedTextInput: EnhancedTextInput,
        sThesaurusSelectField: ThesaurusSelectField,
        sThesaurusTermChooser: ThesaurusTermChooser
    },
    props: ['form', 'fieldName', 'reportId'],
    template: require('./tree.html')
})
export class Tree extends ReactiveVue {

    public form: FormApi;
    public fieldName: string;
    public getTranslatedString = getTranslatedString;

    public writableDefectElements: DefectElement[] = [];

    // Icons
    private deleteIcon = faTrash;
    private plusIcon = faPlusCircle;

    // used to generate an id for v-for feature (v-bind:key)
    private lastId = 1;

    public mounted() {
        this.$on('delete-element', (message) => {
            this.defectElements.splice(message.elementIndex, 1)
        })
    }

    // Fields names
    public elementNameFieldName(elementIndex) {
        return `${this.fieldName}.conditionReportCS.alterationDetails[${elementIndex}.element.translatedString.${this.$i18n.locale}`
    }

    public elementPrecisionFieldName(elementIndex) {
        return `${this.fieldName}.conditionReportCS.alterationDetails[${elementIndex}.precision.translatedString.${this.$i18n.locale}`
    }

    public elementFieldName(elementIndex) {
        return `${this.fieldName}.conditionReportCS.alterationDetails[${elementIndex}`
    }

    public createElement() {
        this.defectElements.push({
            element: createTranslatedString(this.$i18n.locale),
            id: this.lastId++,
            observationAlterationDetails: [],
            precision: createTranslatedString(this.$i18n.locale)
        })
    }

    public deleteElement(elementIndex: number) {
        this.defectElements.splice(elementIndex, 1);
    }

    private get defectElements(): DefectElement[] {
        // defects can be undefined if the report is blank
        const key = `${this.fieldName}.conditionReportCS.alterationDetails`;
        const { values } = this.form.getState();

        let defects = get(values, key);
        if (!defects) {
            defects = [];
            set(values, key, defects);
        }
        return defects;
    }
}